<div fxLayout="column" class="cipo--height--full">
    <div [fxFlex]="!loading() && !tableData()?.length ? 'none' : 'grow'" class="cipo--overflow--auto" cipoKeyboardList>
        @if (tableColumns().length) {
            <table
                #table
                mat-table
                data-testid="datalist-table datalist-table-paged"
                [dataSource]="dataSource"
                class="cipo-table"
                matSort
                [matSortActive]="options()?.sort?.active"
                [matSortDirection]="options()?.sort?.direction"
                (matSortChange)="tableSortChanged($event)">
                <ng-container matColumnDef="select">
                    @if (options().selectable) {
                        <th
                            mat-header-cell
                            data-testid="datalist-header-cell datalist-header-cell-select"
                            *matHeaderCellDef
                            [style.width]="'50px'">
                            <span class="cdk-visually-hidden">{{ "a11y.dataList.selectColumn" | translate }}</span>
                            <mat-checkbox
                                data-testid="datalist-header-cell-checkbox-select-all"
                                [aria-label]="'a11y.dataList.selectAll' | translate"
                                (change)="$event ? toggleAllRows() : null"
                                [checked]="selection().hasValue() && isAllSelected()"
                                [indeterminate]="selection().hasValue() && !isAllSelected()"
                                [disabled]="selectAllDisabled()"></mat-checkbox>
                        </th>
                        <td
                            mat-cell
                            data-testid="datalist-cell datalist-cell-select"
                            *matCellDef="let row"
                            (click)="$event.stopPropagation()">
                            <mat-checkbox
                                data-testid="datalist-cell-checkbox-select-one"
                                [aria-label]="'a11y.dataList.selectRow' | translate"
                                [tabIndex]="-1"
                                (click)="checked()"
                                (change)="$event ? selection().toggle(row) : null"
                                [checked]="selection().isSelected(row)"
                                [disabled]="row.selectable === false"></mat-checkbox>
                        </td>
                    } @else {
                        <th
                            mat-header-cell
                            data-testid="datalist-header-cell datalist-header-cell-select"
                            *matHeaderCellDef
                            [style.width]="'50px'"></th>
                        <td mat-cell data-testid="datalist-cell datalist-cell-select" *matCellDef="let row"></td>
                    }
                </ng-container>
                @for (column of tableColumns(); track column) {
                    <ng-container [matColumnDef]="column.name">
                        <th
                            cipoResizeColumn
                            mat-header-cell
                            [attr.data-testid]="'datalist-header-cell datalist-header-cell-' + column.name"
                            *matHeaderCellDef
                            mat-sort-header
                            [class]="
                                !column.align
                                    ? column.displayFormatId === DISPLAY_FORMAT.Number
                                        ? 'align--end'
                                        : ''
                                    : 'align--' + column.align
                            "
                            [disabled]="!column.sortable"
                            disableClear
                            [style.width]="totalWidth ? (100 / totalWidth) * (column.width ?? 1) + '%' : 'auto'"
                            [title]="column.displayName | translate">
                            @if (column.srOnlyLabel) {
                                <span class="cdk-visually-hidden">{{ column.srOnlyLabel | translate }}</span>
                                <span class="cipo--text--ellipsed" aria-hidden="true">
                                    {{ column.displayName | translate }}
                                </span>
                            } @else {
                                <span class="cipo--text--ellipsed">{{ column.displayName | translate }}</span>
                            }
                        </th>
                        <td
                            mat-cell
                            [attr.data-testid]="'datalist-cell datalist-cell-' + column.name"
                            *matCellDef="let row"
                            [style.textAlign]="column.align">
                            <div class="dl-cell">
                                @if (column["showColorCode"] && !row.empty) {
                                    <span
                                        class="color-code-wrapper dl-cell__color"
                                        [style.backgroundColor]="row | getColorCode"></span>
                                }
                                <cipo-table-cell
                                    class="dl-cell__grow"
                                    [row]="row"
                                    [column]="column"
                                    [noDataPlaceholder]="options().noDataPlaceholder" />
                            </div>
                        </td>
                    </ng-container>
                }
                <ng-container matColumnDef="actions">
                    <th
                        mat-header-cell
                        data-testid="datalist-header-cell datalist-header-cell-actions"
                        *matHeaderCellDef>
                        <span class="cdk-visually-hidden">{{ "a11y.dataList.actionsColumn" | translate }}</span>
                    </th>
                    <td mat-cell data-testid="datalist-cell datalist-cell-actions" *matCellDef="let row">
                        <cipo-table-row-actions
                            [row]="row"
                            [actions]="options().actions(row)"
                            [hasLeftIcons]="hasLeftIcons()"
                            [hasRightIcons]="hasRightIcons()"
                            [triggerTabIndex]="-1"
                            (actionSelected)="selectAction($event, row)" />
                    </td>
                </ng-container>
                @for (footerRow of footerRows(); track footerRow.key) {
                    <ng-container [matColumnDef]="footerRow.key.toString()">
                        <td
                            mat-footer-cell
                            [attr.data-testid]="'datalist-footer-cell datalist-footer-cell-' + footerRow.key.toString()"
                            *matFooterCellDef
                            class="cipo--text-weight--bold cipo--text-size--sm">
                            @if (footerRow.label) {
                                {{ "SqlAggregateFunctionType." + footerRow.label | translate }}
                            }
                        </td>
                    </ng-container>
                    @for (column of tableColumns(); track column.id) {
                        @let footerCellKey = footerRow.key + "_" + column.id;
                        <ng-container [matColumnDef]="footerCellKey">
                            <td
                                mat-footer-cell
                                [attr.data-testid]="'datalist-footer-cell datalist-footer-cell-' + footerCellKey"
                                *matFooterCellDef>
                                @if (footerRow.key === FOOTER_KEYS.COUNT && !footerRow.empty) {
                                    <p class="cipo--text--end">{{ footerRow[column.name] }}</p>
                                } @else {
                                    <cipo-table-cell [column]="column" [row]="footerRow" noDataPlaceholder=" " />
                                }
                            </td>
                        </ng-container>
                    }
                }
                <ng-container matColumnDef="footer_actions">
                    <td
                        mat-footer-cell
                        data-testid="datalist-footer-cell datalist-footer-cell-footer_actions"
                        *matFooterCellDef></td>
                </ng-container>
                <tr
                    mat-header-row
                    data-testid="datalist-header-row"
                    *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
                <tr
                    mat-row
                    data-testid="datalist-row"
                    [attr.tabindex]="!row.empty && options().clickableRows ? -1 : null"
                    (click)="!row.empty && options().clickableRows && rowClick(row, $event)"
                    (keydown.enter)="onRowKey($event, row)"
                    *matRowDef="let row; columns: displayedColumns()"
                    [ngClass]="[
                        row.customClass ? row.customClass : '',
                        row.backgroundColor ? 'cipo-bg--' + row.backgroundColor : '',
                        !row.empty && options().clickableRows ? 'cipo--cursor--pointer' : '',
                        !row.empty && options().clickableRows
                            ? 'cipo-bg-hover--' + (row.hoverColor ?? 'primary-200')
                            : '',
                    ]"></tr>
                @for (footer of footerRows(); track footer.key) {
                    <tr
                        mat-footer-row
                        data-testid="datalist-footer-row"
                        *matFooterRowDef="footerColumns()[$index]; sticky: true"
                        [style.bottom.px]="35 * $index"></tr>
                }
            </table>
        }
    </div>
    <div fxFlex="none">
        @let rowsCount = tableData()?.length ?? 0;
        @if (!loading() && !rowsCount) {
            <div class="m-t-xl">
                <cipo-not-found />
            </div>
        }
        @if (options().pagination) {
            @let serverPagination = serverPaginate();
            @if (serverPagination) {
                <div fxLayout fxLayoutAlign="end center" class="cipo-text--medium-sm cipo-bg--white">
                    @if (rowsCount && !options().hidePagesLoaded && !loading()) {
                        <p
                            fxFlex="none"
                            class="cipo-text--medium-sm p-r cipo--border-right--solid"
                            data-testid="paged-datalist-page-loaded">
                            {{
                                "general.table.pageLoaded"
                                    | translate
                                        : {
                                              page: serverPagination.pageIndex + 1,
                                              total: serverPagination.pagesCount,
                                          }
                            }}
                        </p>
                    }
                    <mat-paginator
                        #serverPaginator
                        data-testid="datalist-paginator datalist-paginator-server"
                        showFirstLastButtons
                        [style]="{ display: !rowsCount ? 'none' : 'block' }"
                        [pageIndex]="serverPagination.pageIndex"
                        [pageSize]="serverPagination.pageSize"
                        [pageSizeOptions]="serverPagination.pageSizeOptions"
                        [length]="serverPagination.length"
                        [disabled]="loading()"
                        (page)="paginationChange($event)" />
                </div>
            } @else {
                <mat-paginator
                    data-testid="datalist-paginator datalist-paginator-client"
                    [style]="{ display: loading() || !rowsCount ? 'none' : 'block' }"
                    #clientPaginator />
            }
        }
    </div>
</div>
